import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

interface Props {
  type: 'beam' | 'wall';
}

export function BearingEnvelopesContainerMenu({ type }: Props) {
  return (
    <SceneMenuContent>
      <AddItemMenuItem
        type={type === 'beam' ? 'beam' : 'bearingEnvelope'}
        userVisibleTerm={type === 'beam' ? 'Beam' : 'Wall'}
      />
    </SceneMenuContent>
  );
}
